/**
 * @module mapbs.components.reportpanel.liegtypselect.liegtypselect
 */

import angular from 'angular';
import './liegtypselect.scss';

const moduleLiegtypselect = angular.module('mapbsLiegtypselectModule', []);

moduleLiegtypselect.run(
    /* ngInject */($templateCache) => {
        $templateCache.put('mapbs/liegtypselect', require('./liegtypselect.html'));
    }
);

/**
 * @type {!angular.Component}
 */
const LiegtypselectComponent = {
    controller: 'mapbsLiegtypselectController as ctrl',
    templateUrl: () => 'mapbs/liegtypselect',
    bindings: {
        'liegtypselectlist': '=mapbsLiegtypselectList',
        'showmodal': '=mapbsLiegtypselectShow',
        'onSelect': '&',
        'onClose': '&',
    },
};

moduleLiegtypselect.component('mapbsLiegtypselect', LiegtypselectComponent);

/**
 * @private
 */
class LiegtypselectController {
    constructor($element, $scope) {
        this.element = $element;
        this.scope = $scope;

        /** @type {string} @private */
        this.reasonForClosing = 'user';
        /**
         * @type {Array}
         */
        this.realEstateOrderBy = {
            'Liegenschaftsparzelle': 0 ,
            'Baurecht': 1 ,
            'Unterbaurecht': 2 ,
            'andere Dienstbarkeit': 3
        };

        this.scope.$watch(
            () => {
                return this.liegtypselectlist;
            },
            (val) => {
                if (val) {
                    this.liegtypselectlist.forEach( item => item['typeSortIndex'] = this.realEstateOrderBy[item.typ]);
                }
            }
        );
    }


    $onInit() {
        const modalElem = this.element.find('.modal');
        modalElem.on('hidden.bs.modal', () => {
            switch (this.reasonForClosing) {
                case 'user':
                    this.onClose();
                    break;
                case 'selection':
                    this.reasonForClosing = 'user';
                    break;
                default:
                    this.onClose();
            }
        });
    }

    liegSelected(lieg) {
        this.reasonForClosing = 'selection';
        this.showmodal = false;
        this.onSelect(lieg);
    }

}

moduleLiegtypselect.controller('mapbsLiegtypselectController', LiegtypselectController);

export default moduleLiegtypselect;
